<template>
  <v-dialog v-model="dialog" max-width="950px">
    <v-card>
      <v-card-title class="blue darken-3 white--text"> </v-card-title>

      <v-card-text>
        <div class="container">
          <v-text-field
            v-model.number="NOTA_APROBACION"
            type="number"
            :readonly="loading_categorias"
            dense
            hide-details
          />

          <div class="container">
            <v-img lazy-src="https://picsum.photos/id/11/10/6" src="img/image5.png"></v-img>

            <div class="text-center">
              <h5 class="mb-0 black--text">CONVENIO ESAM</h5>
              <h5 class="mb-0 mt-0 black--text">ACTA DE NOTAS FINALES</h5>
              <h5 class="mb-0 mt-0 black--text">{{ upper(posgrado.nombre) }}</h5>
            </div>

            <div>
              <p class="mb-0 mt-4"><b>Modulo:</b> {{ modulo.nombre }}</p>
              <p class="mb-0"><b>Docente:</b></p>
              <p class="mb-4"><b>Fecha:</b></p>
            </div>

            <v-progress-linear indeterminate v-if="loading_cursos" />

            <template>
              <v-simple-table class="borde">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="1" rowspan="2" class="borde">MÓDULO</th>
                      <th colspan="2" class="text-center borde">CALIFICACIÓN</th>
                      <th rowspan="2" class="borde">RESULTADO</th>
                    </tr>
                    <tr>
                      <th class="borde text-center">NUMERAL</th>
                      <th class="borde text-center">LITERAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in modulo.inscripciones" :key="ind">
                      <td class="borde">{{ item.name }}</td>
                      <td class="borde text-right">{{ item.numeral }}</td>
                      <td class="borde text-right">{{ item.literal }}</td>
                      <td class="borde text-right">{{ getresultado(item.numeral) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </div>

          <v-btn color="info darken-2" class="ma-2 white--text" @click="crearPDF()">
            Descargar certificado de notas
            <v-icon right dark> mdi-cloud-download </v-icon>
          </v-btn>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style type="text/css">
  .borde {
    border: 1px solid black !important;
  }
</style>

<script>
  export default {
    data: () => ({
      NOTA_APROBACION: 71,
      dialog: false,
      loading_categorias: false,
      loading_cursos: false,
      modulo: { inscripciones: [], nombre: '' },
      posgrado: {},
    }),
    components: {},
    watch: {
      NOTA_APROBACION: function() {},
    },
    methods: {
      openmodal(modulo, posgrado) {
        let vue = this;
        modulo.inscripciones.map((x) => {
          if (!x.estudiante.segundo_apellido) x.estudiante.segundo_apellido = '';
          x.name = `${x.estudiante.primer_apellido} ${x.estudiante.segundo_apellido} ${x.estudiante.nombres}`;
          x.numeral = x.nota_final > x.nota_recuperatorio ? x.nota_final : x.nota_recuperatorio;
          x.literal = vue.literalitox(x.numeral);
          //x.resultado = vue.getresultado(x.numeral);
        });
        this.modulo = modulo;
        this.dialog = true;
        this.posgrado = posgrado;
        window.console.log('..', modulo, posgrado);
      },
      literalitox(num) {
        return this.literal(num);
      },
      upper(t) {
        if (!t) return '';
        return t.toUpperCase();
      },
      getresultado(notaf) {
        if (notaf == null || notaf == '') return 'SIN NOTA';
        if (notaf >= this.NOTA_APROBACION) return 'APROBADO';
        else return 'REPROBADO';
      },
      literal(num) {
        const nums = [
          'CERO',
          'UNO',
          'DOS',
          'TRES',
          'CUATRO',
          'CINCO',
          'SEIS',
          'SIETE',
          'OCHO',
          'NUEVE',
          'DIEZ',
          'ONCE',
          'DOCE',
          'TRECE',
          'CATORCE',
          'QUINCE',
          'DIECISEIS',
          'DIECISIETE',
          'DIECIOCHO',
          'DIECINUEVE',
        ];
        const dece = ['VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA', 'CIEN'];
        if (num < 20) return nums[num];
        const decimo = num % 10;
        const digito = parseInt(num / 10);
        if (decimo == 0) return dece[digito - 2];
        else if (digito == 2) return 'VEINTI' + nums[decimo];
        else return dece[digito - 2] + ' Y ' + nums[decimo];
      },

      addImageProcess(src) {
        var c = document.createElement('canvas');
        return new Promise((resolve, reject) => {
          let img = new Image();
          img.setAttribute('crossorigin', 'anonymous');
          img.onload = () => {
            c.height = img.naturalHeight;
            c.width = img.naturalWidth;
            var ctx = c.getContext('2d');

            ctx.drawImage(img, 0, 0, c.width, c.height);
            resolve(c.toDataURL());
          };
          img.onerror = reject;
          img.src = src;
        });
      },
      async crearPDF() {
        //let cabecera = await this.addImageProcess('img/cabecera_uajms.webp');
        // let cabecera = await this.addImageProcess('img/cabecera_sxx.webp');
        // let pie = await this.addImageProcess('img/piepagina.png');
        const mods = [
          [
            { text: '\nAPELLIDOS Y NOMBRES', rowSpan: 2, style: 'tableHeader', alignment: 'center' },
            { text: 'CALIFICACIÓN', style: 'tableHeader', colSpan: 2, alignment: 'center' },
            {},
            { text: '\nOBSERVACIONES', rowSpan: 2, style: 'tableHeader', alignment: 'center' },
          ],
          [
            {},
            { text: 'NUMERAL', style: 'tableHeader', alignment: 'center' },
            { text: 'LITERAL', style: 'tableHeader', alignment: 'center' },
            {},
          ],
        ];

        var textos = [
          '\n',
          'Que es alumno regular de nuestra Institución en ',
          'jaja',
          { text: 'categoria', bold: true },
          'en ',
          { text: 'programa', bold: true },
          ', el programa contiene ' +
            'modulos' +
            ', se lleva a cabo 1 módulo por mes, a continuación, se detalla los módulos cursados y aprobados:  ',
        ];

        var dd = {
          /*header: {
            image: cabecera,
            width: 594,
            height: 120,
            margin: [0, 0, 0, 0],
          },
          footer: function() {
            return {
              table: {
                body: [
                  [
                    { image: pie, alignment: 'center', width: 594, height: 90 },
                    {
                      text: 'MSc. Eva Saavedra Quinteros',
                      alignment: 'center',
                      style: 'normalText',
                      margin: [-594, 34, 0, 0],
                    },
                    { text: 'DIRECTORA NACIONAL', alignment: 'center', style: 'footerbold', margin: [-594, 50, 0, 0] },
                    { text: 'ESAM BOLIVIA', alignment: 'center', style: 'footerbold', margin: [-594, 62, 0, 0] },
                  ],
                ],
              },
              layout: 'noBorders',
            };
          },*/
          pageMargins: [40, 130, 40, 90],
          content: [
            {
              text: 'LA ESCUELA SUPERIOR DE NEGOCIOS “ESAM” EN CONVENIO CON LA UNIVERSIDAD NACIONAL SIGLO XX.',
              style: 'subheader',
              alignment: 'left',
            },
            { text: 'CERTIFICA:', style: 'header', alignment: 'center' },
            { text: 'sdsdsd', alignment: 'left', margin: [20, 0, 20, 0] },
            {
              text: textos,
              margin: [20, 5, 20, 0],
            },
            '\n',
            {
              style: 'tableExample',
              color: '#444',
              table: {
                widths: [200, 70, 70, 100],
                headerRows: 3,
                body: mods,
              },
              layout: {
                fillColor: function(rowIndex) {
                  if (rowIndex > 1) return rowIndex % 2 === 0 ? '#FFFFEF' : null;
                },
              },
            },
          ],
          styles: {
            header: { fontSize: 25, bold: true, margin: [0, 0, 0, 10] },
            subheader: { fontSize: 15, bold: true, margin: [20, 5, 20, 5] },
            tableExample: { margin: [20, 5, 20, 45] },
            tableHeader: { bold: true, fontSize: 13, color: 'black' },
            footerbold: { bold: true, fontSize: 10 },
          },
          defaultStyle: {
            alignment: 'justify',
          },
        };
        window.pdfMake.fonts = {
          Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
          },
        };
        window.console.log(dd);

        window.pdfMake.createPdf(dd).open();
      },
    },
    mounted() {},
  };
</script>
